import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "tarifs",
  "data-model-id": "3:3728"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavSubsection = _resolveComponent("NavSubsection")!
  const _component_HeroSubsection = _resolveComponent("HeroSubsection")!
  const _component_PricingCardsSubsection = _resolveComponent("PricingCardsSubsection")!
  const _component_DetailsSubsection = _resolveComponent("DetailsSubsection")!
  const _component_FAQSubsection = _resolveComponent("FAQSubsection")!
  const _component_CTASubsection = _resolveComponent("CTASubsection")!
  const _component_FooterSubsection = _resolveComponent("FooterSubsection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavSubsection),
    _createVNode(_component_HeroSubsection),
    _createVNode(_component_PricingCardsSubsection),
    _createVNode(_component_DetailsSubsection),
    _createVNode(_component_FAQSubsection),
    _createVNode(_component_CTASubsection),
    _createVNode(_component_FooterSubsection)
  ]))
}